import { Leaf, Link } from '../types';

export class LeafLink implements Link {
  public constructor(private next: Leaf) {}

  public getNext(): Leaf {
    return this.next;
  }

  public setNext(next: Leaf): void {
    this.next = next;
  }

  public remove(): void {
    this.next = undefined;
  }
}
